import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  schoolData: {},
  loading: false,
};

export const SuperAdminDashboardReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.GET_SELECTED_SCHOOL_INFORMATION:
      return {
        ...state,
        schoolData: payload,
      };

    case ActionTypes.ACTIVATE_OR_DEACTIVATE_SCHOOL:
      return {
        ...state,
        schoolData: {
          ...state.schoolData,
          status: payload,
        },
      };

    case ActionTypes.DELETE_SCHOOL:
      return {
        ...state,
        schoolData: {
          ...state.schoolData,
          user: {
            ...state.schoolData.user,
            deleted: payload,
          },
        },
      };

    case ActionTypes.RESTORE_DELETED_SCHOOL:
      return {
        ...state,
        schoolData: {
          ...state.schoolData,
          status: true,
          user: {
            ...state.schoolData.user,
            deleted: payload,
          },
        },
      };

    case ActionTypes.SUPER_ADMIN_LOADING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};
